<template>
  <div class="modal-form__wrapper">
    <div
      v-for="field in formData.healthInsurance"
      :key="`${id}_specialPatientFormField_${field.name}`"
      :class="[field.class]"
      class="modal-form__item"
    >
      <div
        v-if="field.hasIcon"
        class="modal-form__col modal-form__col--icon"
      >
        <dr-icon
          v-if="field.icon"
          :name="field.icon"
          fill="gray"
          class="modal-form__icon"
        />
      </div>

      <div class="modal-form__col">
        <div class="modal-form__field">
          <dr-field
            :key="`${id}_specialPatient_${field.name}`"
            :ref="`${id}_specialPatient_${field.name}`"
            :id="`${id}_specialPatient_${field.name}`"
            :form.sync="formData"
            :field.sync="field"
            :class="[
              field.value && 'has-value',
              $v.formData.healthInsurance[field.name].$invalid && 'has-error'
            ]"
            class="modal-form__input"
            prefix="specialPatientForm_"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DrField from '@/components/form/field'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'DrSpecialPatientHealthInsurance',

  model: {
    prop: 'insurance',
    event: 'change'
  },

  props: {
    id: {
      type: String,
      required: false,
      default: () => 'HealthInsurance_'
    },

    insurance: {
      type: Object,
      required: false,
      default: () => ({
        healthPlan: null,
        walletNumber: null,
        walletValidity: null
      })
    }
  },

  components: {
    DrField
  },

  validations: {
    formData: {
      healthInsurance: {
        healthPlan: { value: required },

        walletNumber: {
          value: {
            requiredIf (value) {
              if (this.formData.healthInsurance.healthPlan.value) {
                return !!value
              }

              return true
            }
          }
        },

        walletValidity: {
          value: {
            requiredIf (value) {
              if (this.formData.healthInsurance.healthPlan.value) {
                return !!value
              }

              return true
            },

            isSameOrAfter (value) {
              if (value) {
                const now = this.$moment()
                const walletValidity = this.$moment(value, 'DD/MM/YYYY', true)
                return walletValidity.isSameOrAfter(now, 'd')
              }

              return true
            }
          }
        }
      }
    }
  },

  data () {
    return {
      formData: {
        healthInsurance: {
          healthPlan: {
            name: 'healthPlan',
            type: 'search',
            placeholder: 'Buscar convênio',
            disableLocal: true,
            disabled: false,
            hideErrors: true,
            endpoint: 'health_insurance',
            format: '{$name}',
            returnFormat: 'object',
            fields: ['filterLike[hi.name]'],
            value: null,
            hasIcon: true,
            icon: 'healthInsuranceCard',
            class: 'modal-form__item--50'
          },

          walletNumber: {
            name: 'walletNumber',
            type: 'text',
            placeholder: 'Nº da carteira',
            value: null,
            hasIcon: false,
            class: 'modal-form__item--25'
          },

          walletValidity: {
            name: 'walletValidity',
            type: 'text',
            mask: '##/##/####',
            placeholder: 'Validade',
            value: null,
            hasIcon: false,
            class: 'modal-form__item--25'
          }
        }
      }
    }
  },

  watch: {
    'formData.healthInsurance.healthPlan.value': {
      deep: true,
      immediate: false,
      handler (val) {
        this.insurance.healthPlan = val
      }
    },

    'formData.healthInsurance.walletNumber.value': {
      deep: true,
      immediate: false,
      handler (val) {
        this.insurance.walletNumber = val
      }
    },

    'formData.healthInsurance.walletValidity.value': {
      deep: true,
      immediate: false,
      handler (val) {
        this.insurance.walletValidity = val
      }
    },

    'insurance.healthPlan': {
      deep: true,
      immediate: true,
      handler () {
        this.$emit('change', this.insurance)
      }
    },

    'insurance.walletNumber': {
      deep: true,
      immediate: true,
      handler () {
        this.$emit('change', this.insurance)
      }
    },

    'insurance.walletValidity': {
      deep: true,
      immediate: true,
      handler () {
        this.$emit('change', this.insurance)
      }
    }
  },

  mounted () {
    if (this.insurance && this.insurance.healthPlan) {
      this.$refs[`${this.id}_specialPatient_healthPlan`][0].$children[0].searchTerm = this.insurance.healthPlan.name
      this.formData.healthInsurance.healthPlan.value = this.insurance.healthPlan
      this.formData.healthInsurance.walletNumber.value = this.insurance.walletNumber
      this.formData.healthInsurance.walletValidity.value = this.insurance.walletValidity

      const autocomplete = this.$refs[`${this.id}_specialPatient_healthPlan`][0]
        .$el
        .querySelectorAll('div')

      autocomplete.forEach(div => div.classList.add('is-disabled'))
    }
  }
}
</script>
